<template>
    <div class="subject-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/new_examination' }">新高考</el-breadcrumb-item>
            <el-breadcrumb-item>选科查询</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="zy-school">
            <el-tabs type="border-card" slot="content" class="rank-box zy-list" @tab-click="handleChangeCard" v-model="active_card_index">
                <el-tab-pane :label="card" v-for="(card,key) in card_list" :key="key">
                </el-tab-pane>
                <div v-if="active_card_index == 0">
                    <h4>选择科目</h4>
                    <div class="subject-select">
                        <div>
                            <div class="select-item-desc">
                                首选科目
                                <span>(物理、历史任选1门，必选)</span>
                            </div>
                            <el-checkbox-group :max="1" v-model="search.select_first">
                                <el-checkbox v-for="(item, index) in course_list1" :key="index" :label="item.key">
                                    {{ item.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div>
                            <div class="select-item-desc">
                                再选科目
                                <span>(任意选择1-2个再选科目)</span>
                            </div>
                            <el-checkbox-group :max="2" v-model="search.select_second">
                                <el-checkbox v-for="(item, index) in course_list2" :key="index" :label="item.key">
                                    {{ item.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <el-button @click="getSubjectToMajorList()">查询可报专业</el-button>
                    </div>
                    <h4>
                        可报专业
                        <span>
                            (根据最近年份推荐)
                        </span>
                    </h4>
                    <el-form v-if="total > -1" ref="search_form" :model="search" inline label-position="left">
                        <el-form-item label="学历层次：">
                            <el-select v-model="search.gradation" :style="{ width: gradation_width + 'px'}" @change="selectType($event,'gradation')">
                                <el-option :ref="'gradation' + item.dic_code" v-for="item in type_list1" :key="item.dic_code" :label="item.dic_value" :value="item.dic_code"></el-option>
                                <el-option :ref="'gradation' + item.dic_code" v-for="item in type_list2" :key="item.dic_code" :label="item.dic_value" :value="item.dic_code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="省份：">
                            <el-select v-model="search.province_id" :style="{ width: province_width + 'px'}" @change="selectType($event,'province')">
                                <el-option :ref="'province' + item.provinceid" v-for="(item, index) in province_list" :key="index" :label="item.name" :value="item.provinceid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="院校类型：">
                            <el-select v-model="search.scl_type" style="width: 60px" @change="searchData()">
                                <el-option v-for="(item, index) in type_list" :key="index" :label="item.dic_value" :value="item.dic_code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="办学类型：" class="form-item">
                            <el-select v-model="search.scl_nature" :style="{ width: scl_nature_width + 'px'}" @change="selectType($event,'scl_nature')">
                                <el-option :ref="'scl_nature' + item.dic_code" v-for="(item, index) in type_list3" :key="index" :label="item.dic_value" :value="item.dic_code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="input-item">
                            <el-input v-model="search.key_word" placeholder="搜索学校/专业" @keyup.enter.native="searchData()">
                                <img slot="suffix" @click="searchData()" src="../../assets/images/sousuo.png" alt="搜索">
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-table v-if="total > -1" :data="paginate_data" stripe style="width: 100%" border class="tools-table-box" :key="Math.random()">
                        <el-table-column label="院校名称" prop="scl_name" show-overflow-tooltip />
                        <el-table-column label="专业（类）名称" prop="spname" min-width="150" show-overflow-tooltip />
                        <el-table-column label="类中所含专业" prop="" />
                        <el-table-column label="首选科目" prop="first_choose_text" />
                        <el-table-column label="再选科目" prop="second_choose_text" />
                        <el-table-column label="再选科目要求" prop="sp_info" min-width="160" show-overflow-tooltip />
                    </el-table>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total" :page-size="8"  @current-change="handleChangePage" :current-page.sync='page' v-if="total > 0">
                    </el-pagination>
                </div>
                <div v-else-if="active_card_index == 1">
                    <h4>
                        选择专业
                        <span>
                            (添加“招生专业”，查询专业的选科要求)
                        </span>
                    </h4>
                    <div class="subject-select major-select">
                        <el-table v-if="select_major_list.length > 0" :data="select_major_list" stripe style="width: 100%" border class="tools-table-box" :key="Math.random()">
                            <el-table-column label="院校名称" prop="scl_name" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="专业(类)名称" prop="spname" min-width="170" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="类中所含专业" prop="">
                            </el-table-column>
                            <el-table-column label="首选科目" prop="first_choose_text">
                            </el-table-column>
                            <el-table-column label="再选科目" prop="second_choose_text">
                            </el-table-column>
                            <el-table-column label="再选科目要求" prop="sp_info" min-width="130" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column align="right" width="52">
                                <template slot-scope="scope">
                                    <img src="@/assets/images/query_subject_icon1.png" @click="deleteMajorSchool(scope.$index)" class="remove-icon">
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button @click="addMajorTemplate">
                            <img src="@/assets/images/add_major_icon.png">
                            添加专业
                        </el-button>
                    </div>
                    <h4>
                        可选科目组合
                    </h4>
                    <div class="course-com">如需填报以上专业，您有以下{{ Object.keys(select_combination_list).length }}种选科组合可以选择</div>
                    <div class="not-select">
                        <span>我不想选的科目：</span>
                        <el-checkbox-group v-model="combination_form.select" @change="changeCombinationList">
                            <el-checkbox v-for="(item, index) in combination_infor.subject_info" :key="item.key" :label="item.name">
                                {{ item.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="comm-list">
                        <div v-for="(item, index) in select_combination_list" :key="index">{{ item }}</div>
                    </div>
                </div>
                <div v-else class="xuankao-list">
                    <h4>
                        选考科目
                    </h4>
                    <el-form inline label-position="left">
                        <el-form-item label="学历层次：">
                            <el-select v-model="search.gradation" :style="{ width: gradation_width + 'px'}" @change="selectType($event,'gradation')">
                                <el-option :ref="'gradation' + item.dic_code" v-for="item in type_list1" :key="item.dic_code" :label="item.dic_value" :value="item.dic_code"></el-option>
                                <el-option :ref="'gradation' + item.dic_code" v-for="item in type_list2" :key="item.dic_code" :label="item.dic_value" :value="item.dic_code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="省份：">
                            <el-select v-model="search.province_id" :style="{ width: province_width + 'px'}" @change="selectType($event,'province')">
                                <el-option :ref="'province' + item.provinceid" v-for="(item, index) in province_list" :key="index" :label="item.name" :value="item.provinceid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="院校类型：">
                            <el-select v-model="search.scl_type" style="width: 60px" @change="searchData()">
                                <el-option v-for="(item, index) in type_list" :key="index" :label="item.dic_value" :value="item.dic_code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="办学类型：" class="form-item">
                            <el-select v-model="search.scl_nature" :style="{ width: scl_nature_width + 'px'}" @change="selectType($event,'scl_nature')">
                                <el-option :ref="'scl_nature' + item.dic_code" v-for="(item, index) in type_list3" :key="index" :label="item.dic_value" :value="item.dic_code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="input-item">
                            <el-input v-model="search.key_word" placeholder="搜索学校/专业" @keyup.enter.native="searchData()">
                                <img slot="suffix" @click="searchData()" src="../../assets/images/sousuo.png" alt="搜索">
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-table :data="paginate_data" stripe style="width: 100%" border class="tools-table-box" :key="Math.random()">
                        <el-table-column label="院校名称" prop="scl_name" show-overflow-tooltip />
                        <el-table-column label="专业（类）名称" prop="spname" min-width="150" show-overflow-tooltip />
                        <el-table-column label="类中所含专业" prop="" />
                        <el-table-column label="首选科目" prop="first_choose_text" />
                        <el-table-column label="再选科目" prop="second_choose_text" />
                        <el-table-column label="再选科目要求" prop="sp_info" min-width="160" show-overflow-tooltip />
                    </el-table>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total" :page-size="8"  @current-change="handleChangePage" :current-page.sync='page' v-if="total > 0">
                    </el-pagination>
                </div>
                <div v-if="total === -1 && active_card_index == 0" class="no-data-box">
                    <img src="../../assets/images/null.png" alt="没有数据">
                    <p>暂无可报专业，请选择科目</p>
                </div>
            </el-tabs>
        </div>
        <el-dialog title="添加专业" width="1000px" :show-close="false" :visible.sync="dialogVisible" class="dialog-box dialog-subject">
            <img src="@/assets/images/close.png" alt="关闭" @click="dialogVisible=false" class="dialog-close">
            <el-form :model="major_search" :inline="true">
                <el-form-item class="form-item-more" :class="moreVisible?'active-more':''">
                    <span class="search-more-view" @click="moreTemplate()">
                    <img v-if="!moreVisible" src="@/assets/images/subject_more_icon.png"/>
                    <img v-else src="@/assets/images/subject_more_icon1.png"/>
                    更多筛选
                    </span>
                </el-form-item>
                <el-form-item class="input-item">
                    <el-input v-model="major_search.key_word" placeholder="搜索学校/专业名称">
                        <img slot="suffix" @click="searchMajorData()" src="../../assets/images/sousuo.png" alt="搜索">
                    </el-input>
                </el-form-item>
            </el-form>
            <el-table :data="select_paginate_data" stripe style="width: 100%" border class="tools-table-box" :row-class-name="tableRowClassName" @row-click="handleSelectSchool">
                <el-table-column label="院校名称" prop="scl_name" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="专业(类)名称" prop="spname" min-width="170" show-overflow-tooltip>
                </el-table-column>
                <!-- <el-table-column label="类中所含专业" prop="first_choose_text">
                </el-table-column> -->
                <el-table-column label="首选科目" prop="first_choose_text">
                </el-table-column>
                <el-table-column label="再选科目" prop="second_choose_text">
                </el-table-column>
                <el-table-column label="再选科目要求" prop="sp_info" min-width="130" show-overflow-tooltip>
                </el-table-column>
                <el-table-column width="53">
                    <template slot-scope="scope">
                        <img v-if="!scope.row.checked" src="@/assets/images/select_icon1.png">
                        <img v-else src="@/assets/images/select_icon2.png">
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="select_total" :page-size="8" @current-change="getMajorToSubjectList" :current-page.sync="select_page" v-if="select_total > 0">
            </el-pagination>
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button class="btn-confirm" @click="dialogVisible = false">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog :show-close="false" :visible.sync="moreVisible" class="dialog-box dialog-more dialog-subject">
            <img src="@/assets/images/close.png" alt="关闭" @click="moreVisible=false" class="dialog-close">
            <div class="more-nav">
                <span v-for="(item, index) in more_list" :class="active_more_index === index ? 'active-nav': ''" @click="handleMoreClick(index)">{{ item }}</span>
            </div>
            <div v-if="active_more_index === 0" class="more-select">
                <el-form :model="major_search" label-width="100px">
                    <el-form-item label="省份：">
                        <el-checkbox-group v-model="major_search.province_id">
                            <el-checkbox v-for="(item, index) in add_province_list" :key="index" :label="item.provinceid">
                                {{ item.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="学历层次：">
                        <el-checkbox-group v-model="major_search.gradation">
                            <el-checkbox v-for="(item, index) in add_type_list1" :key="index" :label="item.dic_code">
                                {{ item.dic_value }}
                            </el-checkbox>
                        </el-checkbox-group>
                        <el-checkbox-group v-model="major_search.scl_nature_type">
                            <el-checkbox v-for="(item, index) in add_type_list2" :key="index" :label="item.dic_code">
                                {{ item.dic_value }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="院校类型：">
                        <el-checkbox-group v-model="major_search.scl_type">
                            <el-checkbox v-for="(item, index) in add_type_list" :key="index" :label="item.dic_code">
                                {{ item.dic_value }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else class="more-select">
                <el-row class="query-subject-select-major">
                    <el-col :span="5">
                    <el-scrollbar wrap-class="vertical_scrollbar" style="height:325px">
                        <div v-for="(item, index) in major_level_list1" :key="index" :class="index == major_active_level1 ? 'select-major-active' : ''" @click="changeMajorLevel1(index)">{{ item }}</div>
                    </el-scrollbar>
                    </el-col>
                    <el-col :span="6">
                    <el-scrollbar wrap-class="vertical_scrollbar" style="height:325px">
                        <div v-for="(item, index) in major_level_list2" :key="index" :class="index === major_active_level2 ? 'select-major-active' : ''" @click="changeMajorLevel2(index)">{{ item.level2_name }}</div>
                    </el-scrollbar>
                    </el-col>
                    <el-col :span="6">
                    <el-scrollbar wrap-class="vertical_scrollbar" style="height:325px">
                        <div v-for="(item, index) in major_level_list3" :key="index" :class="index === major_active_level3 ? 'select-major-active' : ''" @click="changeMajorLevel3(index)">{{ item.level3_name }}</div>
                    </el-scrollbar>
                    </el-col>
                    <el-col :span="7">
                    <el-scrollbar wrap-class="vertical_scrollbar" style="height:325px">
                        <el-form ref="form" label-width="0px" class="query-subject-form2">
                            <el-form-item>
                                <el-checkbox v-model="major_search.all_check" label="全部" :indeterminate="isIndeterminate" style="margin-top: 24px;" @change="handleCheckAllChange" />
                                <el-checkbox-group v-model="major_search.spec_id">
                                <el-checkbox v-for="item in major_level_list4" :key="item.special_id" :label="item.special_id">{{ item.special_name }}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                    </el-scrollbar>
                    </el-col>
                </el-row>
            </div>
            <div class="dialog-footer">
                <el-button @click="resetSelectData">重置</el-button>
                <el-button class="btn-confirm" @click="searchMajorData()">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getSearchDic } from '@/api/zhiyuan'
import { getBaseData, getSubjectToMajorList, getMajorCombinationList, getMajorToSubjectList, getAllLevel3, getAllLevel2, getSpecialList } from '@/api/query_subject'
export default {
    data() {
        return {
            height: window.innerHeight,
            card_list:{ 0: '由科目选专业', 1: '由专业选科目', 2: '选考科目查询' },
            active_card_index: 0,
            course_list1: [],
            course_list2: [],
            checked_selected_list: [],
            total: -1,
            page_size: 8,
            page: 1,
            paginate_data: [],
            search: {
                select_first: [],
                select_second: [],
                key_word: '',
                province_id: '0',
                gradation: '0',
                scl_type: '0',
                scl_nature: '0',
                scl_nature_type: '0'
            },
            type_list: [{ dic_code: '0', dic_value: '全部' }],
            type_list1: [{ dic_code: '0', dic_value: '全部' }],
            type_list2: [],
            type_list3: [{ dic_code: '0', dic_value: '全部' }],
            province_list: [{ provinceid: '0', name: '全部' }],
            gradation_width: 60,
            province_width: 60,
            scl_nature_width: 60,
            dialogVisible: false,
            moreVisible: false,
            major_search: {
                spec_id: [],
                key_word: '',
                province_id: [],
                gradation: [],
                scl_type: [],
                scl_nature: [],
                scl_nature_type: [],
                all_check: false
            },
            major_level_list1: { 1: '本科', 2: '专科' },
            major_level_list2: [],
            major_level_list3: [],
            major_level_list4: {},
            major_active_level1: 1,
            major_active_level2: 0,
            major_active_level3: 0,
            select_paginate_data: [],
            select_page: 1,
            select_page_size: 8,
            select_total: 0,
            isIndeterminate: false,
            combination_infor: {},
            select_combination_list: [],
            combination_form: {
                select: []
            },
            select_major_list: [],
            add_province_list: [],
            add_type_list: [],
            add_type_list1: [],
            add_type_list2: [],
            active_more_index: 0,
            more_list: ['学校', '专业']
        }
    },
    mounted () {
        this.geDicList()
        const tmp = {
            index: sessionStorage.getItem('active_index') || 0
        }
        this.handleChangeCard(tmp)
        // this.getBaseData()
    },
    methods: {
        handleChangeCard(e) {
            this.active_card_index = e.index
            if (e.index === '1') {
                this.select_major_list = []
                Object.assign(this.$data.combination_form, this.$options.data().combination_form)
                this.getMajorCombinationList()
            } else {
                Object.assign(this.$data.search, this.$options.data().search)
                this.page = 1
                this.total = -1
                this.paginate_data = []
                this.gradation_width = 60
                this.province_width = 60
                this.scl_nature_width = 60
                if (e.index === '2') {
                    this.getMajorToSubjectList()
                } else {
                    this.getBaseData()
                }
            }
        },
        handleCheckAllChange(data) {
            const spec_ids = this.major_level_list4.map(item => { return item.special_id })
            this.major_search.spec_id = data ? spec_ids : []
            this.isIndeterminate = false
        },
        handleChangePage() {
            if (this.active_card_index == 0) {
                this.getSubjectToMajorList()
            } else if (this.active_card_index == 2) {
                this.getMajorToSubjectList()
            }
        },
        // 获取字典数据
        geDicList() {
            getSearchDic().then(res => {
                this.province_list.push(...res.data.province)
                this.type_list.push(...res.data.scl_type)
                this.type_list1.push(...res.data.gradation)
                this.type_list2.push(...res.data.edu_type)
                this.type_list3.push(...res.data.scl_nature)
                this.add_province_list.push(...res.data.province)
                this.add_type_list.push(...res.data.scl_type)
                this.add_type_list1.push(...res.data.gradation)
                this.add_type_list2.push(...res.data.edu_type)
            })
        },
        // 基础数据获取
        getBaseData() {
            const course_list1 = []
            const course_list2 = []
            getBaseData().then(res => {
                const data = res.data
                for (const key in data.subject_info) {
                if (data.subject_info.hasOwnProperty(key)) {
                    const element = data.subject_info[key]
                    if (key === 'wl' || key === 'ls') {
                    course_list1.push(element)
                    } else {
                    course_list2.push(element)
                    }
                }
                }
                this.course_list1 = [...course_list1]
                this.course_list2 = [...course_list2]
            })
        },
        // 改变筛选条件
        selectType(dic_code, type) {
            let width
            switch (type) {
                case 'gradation':
                    width = this.$refs['gradation' + dic_code][0].$el.getElementsByTagName('span')[0].offsetWidth
                    this.gradation_width = width + 30
                    if(Number(dic_code) > 1000) {
                        this.search.scl_nature_type = dic_code
                        this.search.gradation = '0'
                    } else {
                        this.search.scl_nature_type = '0'
                        this.search.gradation = dic_code
                    }
                break
                case 'province':
                    width = this.$refs['province' + dic_code][0].$el.getElementsByTagName('span')[0].offsetWidth
                    this.province_width = width + 30
                break
                case 'scl_nature':
                    width = this.$refs['scl_nature' + dic_code][0].$el.getElementsByTagName('span')[0].offsetWidth
                    this.scl_nature_width = width + 30
                break
                default:
                break
            }
            this.$forceUpdate()
            this.searchData()
        },
        // 搜索
        searchData() {
            this.page = 1
            if (this.active_card_index == 0) {
                this.getSubjectToMajorList()
            } else if (this.active_card_index == 2) {
                this.getMajorToSubjectList()
            }
        },
        // 添加专业搜索
        searchMajorData() {
            this.select_page = 1
            this.moreVisible = false
            this.getMajorToSubjectList()
        },
        // 由科目选专业列表
        getSubjectToMajorList() {
            const params = { ...this.search }
            if (this.search.select_first.length === 0) {
                this.$message({
                    message: '请选择科目',
                    type: 'warning'
                })
                return
            }
            params.subject = [...this.search.select_first, ...this.search.select_second].join(',')
            params.page = this.page
            params.page_size = this.select_page_size
            getSubjectToMajorList(params).then(res => {
                const data = res.data
                this.total = data.count
                this.paginate_data = data.list
            })
        },
        // 选考科目查询
        getMajorToSubjectList() {
            let params = {}
            if (this.active_card_index == 1) {
                params = { ...this.major_search }
                params.page = this.select_page
                params.page_size = this.select_page_size
            } else {
                params = { ...this.search }
                params.page = this.page
                params.page_size = this.page_size
            }
            getMajorToSubjectList(params).then(res => {
                if (this.active_card_index == 1) {
                    this.select_paginate_data = res.data.list
                    this.select_total = res.data.count
                    this.select_paginate_data = res.data.list.map(item => {
                        const index_tmp = this.select_major_list.findIndex(val => { return val.ssp_id === item.ssp_id })
                        if (index_tmp !== -1) {
                            item.checked = true
                        } else {
                            item.checked = false
                        }
                        return item
                    })
                } else {
                    this.paginate_data = res.data.list
                    this.total = res.data.count
                }
            })
        },
        // 获取科目组合
        getMajorCombinationList() {
            const ssp_ids = this.select_major_list.map(val => { return val.ssp_id })
            const params = {
                ssp_ids: ssp_ids.join(',')
            }
            getMajorCombinationList(params).then(res => {
                this.combination_infor = { ...res.data }
                this.select_combination_list = { ...res.data.list }
            })
        },
        // 我不选组合
        changeCombinationList() {
            this.select_combination_list = []
            this.select_combination_list = this.combination_infor.list.filter((item) => !this.combination_form.select.some((val) => { return item.indexOf(val) !== -1 }))
        },
        // 添加专业回显
        addMajorTemplate() {
            this.dialogVisible = true
            this.select_page = 1
            Object.assign(this.$data.major_search, this.$options.data().major_search)
            this.select_paginate_data = []
            this.getMajorToSubjectList()
            this.getAllLevel2()
        },
        getMajorToSubjectList() {
            let params = {}
            if (this.active_card_index == 1) {
                params = { ...this.major_search }
                params.page = this.select_page
                params.page_size = this.select_page_size
            } else {
                params = { ...this.search }
                params.page = this.page
                params.page_size = this.page_size
            }
            getMajorToSubjectList(params).then(res => {
                if (this.active_card_index == 1) {
                    this.select_paginate_data = res.data.list
                    this.select_total = res.data.count
                    this.select_paginate_data = res.data.list.map(item => {
                        const index_tmp = this.select_major_list.findIndex(val => { return val.ssp_id === item.ssp_id })
                        if (index_tmp !== -1) {
                        item.checked = true
                        } else {
                        item.checked = false
                        }
                        return item
                    })
                } else {
                this.paginate_data = res.data.list
                this.total = res.data.count
                }
            })
        },
        // 选择专业
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex
        },
        handleSelectSchool(row) {
            row.checked = !row.checked
            this.$set(this.select_paginate_data, row.index, row)
            if (row.checked) {
                this.select_major_list.push(row)
            } else {
                const index = this.select_major_list.findIndex(val => { return val.ssp_id === row.ssp_id })
                this.select_major_list.splice(index, 1)
            }
            this.getMajorCombinationList()
        },
        // 删除添加专业
        deleteMajorSchool(index) {
            this.select_major_list.splice(index, 1)
            this.getMajorCombinationList()
        },
        // 更多筛选回显
        moreTemplate() {
            this.moreVisible = true
            this.major_search.province_id = []
            this.major_search.gradation = []
            this.major_search.scl_type = []
            this.major_search.scl_nature = []
            this.major_search.scl_nature_type = []
            this.major_search.spec_id = []
            this.isIndeterminate = false
            this.major_search.all_check = false
            this.active_more_index = 0
        },
        // 一级专业分类
        getAllLevel2() {
            const level1 = this.major_active_level1
            getAllLevel2(level1).then(res => {
                this.major_level_list2 = res.data
                this.getAllLevel3()
            })
        },
        // 二级专业分类
        getAllLevel3() {
            const params = {
                level1: this.major_active_level1,
                level2: this.major_level_list2[this.major_active_level2].level2
            }
            getAllLevel3(params).then(res => {
                this.major_level_list3 = res.data
                this.getSpecialList()
            })
        },
        // 三级专业分类
        getSpecialList() {
            getSpecialList('', this.major_active_level1, this.major_level_list2[this.major_active_level2].level2, this.major_level_list3[this.major_active_level3].level3).then(res => {
                this.major_level_list4 = res.data.data.data
            })
        },
        // 改变一级专业
        changeMajorLevel1(index) {
            this.major_active_level1 = index
            this.major_active_level2 = 0
            this.major_active_level3 = 0
            this.major_search.all_check = false
            this.major_search.spec_id = []
            this.isIndeterminate = false
            this.major_level_list2 = []
            this.major_level_list3 = []
            this.major_level_list4 = []
            this.getAllLevel2()
        },
        // 改变二级专业
        changeMajorLevel2(index) {
            this.major_active_level2 = index
            this.major_active_level3 = 0
            this.major_search.all_check = false
            this.isIndeterminate = false
            this.major_search.spec_id = []
            this.major_level_list3 = []
            this.major_level_list4 = []
            this.getAllLevel3()
        },
        // 改变三级专业
        changeMajorLevel3(index) {
            this.major_active_level3 = index
            // this.major_search.all_check = false
            this.isIndeterminate = false
            // this.major_search.spec_id = []
            this.major_level_list4 = []
            this.getSpecialList()
        },
        handleMoreClick(index) {
            this.active_more_index = index
        },
        // 重置数据
        resetSelectData() {
            this.major_search.all_check = false
            this.major_search.spec_id = []
            this.major_search.province_id = []
            this.major_search.gradation = []
            this.major_search.scl_type = []
            this.major_search.scl_nature = []
            this.major_search.scl_nature_type = []
            this.isIndeterminate = false
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    ::v-deep .el-checkbox {
        width: 106px;
        height: 50px;
        background: #ffffff;
        border: 1px solid #e1e4eb;
        border-radius: 8px;
        font-size: 16px;
        color: #5e6166;
        line-height: 50px;
        text-align: center;
        .el-checkbox__inner {
            width: 20px;
            height: 20px;
            background: #fff!important;
            border-radius: 4px;
            border: 1px solid #e5dcd8!important;
        }
        .el-checkbox__input.is-checked {
            .el-checkbox__inner {
                background: #ff6524!important;
                border: 1px solid #ff6524!important;
            }
        }
        &.is-checked {
            background: #fff6f3;
            border: 1px solid #ff6524;
            .el-checkbox__label {
                color: #ff6524!important;
            }
        }
        .el-checkbox__inner::after {
            top: 3px;
            left: 7px;
            height: 8px;
            width: 4px;
        }
    }
    .zy-school {
        @include gwidth;
        margin-top: 24px;
        h4 {
            font-size: 20px;
            font-weight: 600;
            color: #2c2e33;
            line-height: 28px;
            margin: 8px 0 16px 0;
            span {
                color: #FF933D;
            }
        }
        h4:before {
            content: '';
            display: inline-block;
            width: 3px;
            height: 20px;
            background: #ff6524;
            position: relative;
            top: 3px;
            margin-right: 8px;
        }
        .subject-select {
            background: #f7faff;
            border: 1px solid #e1e4eb;
            border-radius: 10px;
            padding: 32px;
            display: flex;
            justify-content: space-between;
            align-items: end;
            margin-bottom: 32px;
            .select-item-desc {
                font-size: 16px;
                color: #2c2e33;
                line-height: 22px;
                span {
                    color: #FF933D;
                }
                margin-bottom: 12px;
            }
        }
        .el-button {
            width: 156px;
            height: 50px;
            background: linear-gradient(90deg,#ffa94a, #ff913c);
            border-radius: 8px;
            font-size: 18px;
            border: none!important;
            color: #ffffff!important;
        }
        ::v-deep .el-form-item {
            margin-bottom: 16px;
            .el-form-item__label {
                color: #909399;
                font-size: 14px;
                padding: 0;
                width: auto!important;
            }
        }
        .el-form-item:not(:last-child) {
            margin-right: 72px;
        }
        .form-item {
            margin: 0!important;
        }
        ::v-deep .el-select {
            .el-input__icon {
                color: #ff6524;
            }
            .el-input__inner {
                border: none!important;
                font-size: 14px!important;
                color: #ff6524;
                line-height: 20px;
                padding: 0;
            }
            
        }
        ::v-deep .el-table--border {
            th {
                background: #f5f7fa!important;
                padding: 8px 0;
            }
            td {
                padding: 10px 0;
            }
            .remove-icon {
                position: relative;
                left: -5px;
                top: 2px;
            }
        }
        .major-select {
            padding: 16px;
            display: block;
            text-align: center;
            ::v-deep .el-table--border {
                th {
                    background: #f0f2f5!important;
                }
            }
            ::v-deep .el-button {
                margin: 25px 0 8px 0;
                span {
                    position: relative;
                    top: -2px;
                }
                img {
                    position: relative;
                    top: 3px;
                }
            }
        }
        .course-com {
            background: #fff7eb;
            border-radius: 10px;
            font-size: 16px;
            text-align: center;
            color: #fe9f0a;
            line-height: 22px;
            padding: 11px;
        }
        .not-select {
            display: flex;
            margin-top: 24px;
            > span {
                font-size: 16px;
                color: #2c2e33;
                line-height: 22px;
                margin-right: 8px;
            }
            ::v-deep .el-checkbox {
                height: 22px!important;
                line-height: 22px;
                border: none!important;
                margin-right: 32px;
                background: none!important;
                width: 60px;
            }
        }
        .comm-list {
            display: flex;
            // justify-content: space-between;
            margin-top: 20px;
            flex-wrap: wrap;
            div {
                flex: 0 0 269px;
                height: 52px;
                line-height: 52px;
                background: #ffffff;
                border: 1px solid #e1e4eb;
                border-radius: 8px;
                text-align: center;
                font-size: 16px;
                color: #5e6166;
                margin-bottom: 8px;
                margin-right: 16px;
            }
            div:nth-child(4n) {
                margin-right: 0px;
            }
        }
        .xuankao-list {
            .input-item {
                position: absolute;
                right: 24px;
                top: 24px;
            }
            .el-form-item {
                margin-bottom: 4px;
            }
        }
    }
    ::v-deep .input-item {
        float: right;
        margin: 0;
        img {
            position: relative;
            top: 5px;
        }
        .el-input__inner {
            width: 320px!important;
            height: 44px!important;
            background: #ffffff!important;
            border: 1px solid #e1e4eb!important;
            border-radius: 8px;
            font-size: 14px!important;
        }
    }
    .dialog-subject {
        ::v-deep .el-dialog {
            padding: 32px 40px;
            height: 720px;
            .el-form-item {
                width: auto;
                border: none;
                padding: 0;
                margin-bottom: 6px;
            }
            .dialog-close {
                position: absolute;
                top: 32px;
                right: 40px;
                width: 24px;
                height: 24px;
            }
            .form-item-more {
                width: 108px;
                height: 42px;
                background: #ffffff;
                border: 1px solid #e1e4eb;
                border-radius: 8px;
                line-height: 42px;
                text-align: center;
                font-size: 16px;
                color: #909399;
                cursor: pointer;
                img {
                    position: relative;
                    top: 2px;
                }
            }
            .active-more {
                border: 1px solid #ff6524;
                color: #ff6524;
            }
            .input-item {
                .el-input__inner {
                    padding: 0 40px 0 16px;
                }
                img {
                    position: relative;
                    right: 4px;
                }
            }
            .el-dialog__body {
                margin-top: 24px;
            }
        }
        ::v-deep .el-table--border {
            // overflow-y: scroll;
            th {
                background: #f5f7fa!important;
                padding: 8px 0;
            }
            td {
                padding: 10px 0;
            }
            img {
                position: relative;
                top: 4px;
                left: 5px;
            }
        }
        .dialog-footer {
            display: flex;
            justify-content: center;
            margin-top: 24px;
        }
        .el-button {
            width: 100px;
            height: 44px;
            background: #ffffff!important;
            border: 1px solid #c4c7cc!important;
            border-radius: 8px;
            color: #5e6166!important;
        }
        .btn-confirm {
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            border: none!important;
            color: #ffffff!important;
            margin-left: 16px;
        }
    }
    .dialog-more {
        position: absolute;
        top: 40px;
        ::v-deep .el-dialog {
            padding: 0px 24px;
            width: 940px;
            height: 530px;
            background: rgba(255,255,255,0.80);
            border-radius: 10px;
            box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.32); 
            backdrop-filter: blur(6px);
            .dialog-close {
                right: 24px;
                top: 30px;
            }
            .more-nav {
                span {
                    width: 68px;
                    height: 36px;
                    display: inline-block;
                    border-radius: 4px;
                    margin-right: 12px;
                    color: #999390;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 36px;
                    text-align: center;
                    cursor: pointer;
                }
                .active-nav {
                    background: #ffe9df;
                    color: #ff6524;
                }
            }
            .more-select {
                background: rgba(45,48,54,0.04);
                border-radius: 8px;
                padding: 0 20px;
                margin-top: 16px;
            }
            .el-checkbox {
                height: 34px!important;
                line-height: 34px;
                border: none!important;
                margin-right: 32px;
                background: none!important;
                width: 60px;
            }
            .el-checkbox-group {
                display: inline-block;
            }
            .el-form-item__label {
                line-height: 36px;
            }
            .el-form {
                padding-top: 8px;
            }
            .el-form-item {
                background: none;
                margin-bottom: 0;
                height: auto!important;
                .el-form-item__label {
                    color: #2c2e33;
                    font-size: 16px;
                    text-align: right;
                }
            }
            .vertical_scrollbar {
                overflow-x: hidden;
                .el-form-item {
                    margin: 0;
                }
                .el-form-item__content {
                    div {
                        margin: 0!important;
                    }
                }
                .el-checkbox {
                    display: block;
                    width: 100%;
                    text-align: left;
                    margin: 0!important;
                }
            }
        }
    }
    .query-subject-select-major {
        .el-col-6, .el-col-7 {
        padding-left: 24px;
        }
        .el-col:not(:last-child) {
        border-right: 1px solid #e1e3e6;
        }
        .el-col {
            padding-top: 8px;
            .vertical_scrollbar {
                div {
                font-size: 14px;
                line-height: 20px;
                margin-top: 20px;
                color: #66605e;
                cursor: pointer;
                padding-right: 5px;
                }
                div:last-child {
                margin-bottom: 20px;
                }
                .select-major-active {
                    color: #ff6524;
                }
            }
        }
    }
    .no-data-box {
        text-align: center;
        position: relative;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-top: 160px;
        img {
            width: 110px;
            height: 110px;
        }
        p {
            font-size: 16px;
            text-align: center;
            color: #abaeb3;
        }
    }
</style>